import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mockEndpointDelay } from '@vi-iot/client';

import {
  DataBooleanStatus,
  KeyValueStorage,
  SavedNumberOfInstallations,
} from './vitoguide-backend-settings.model';
import { delay } from 'rxjs/operators';
import {
  defaultDashboardTilesOrder,
  defaultPageSize,
  SettingsPreferences,
  TutorialsData,
  TutorialType,
} from '@store';

@Injectable()
export class VitoguideBackendSettingsMockApi {
  settingsPreferences = {
    preferences: {
      notifications: 'on',
      temperature: 'celsius',
      flowRate: 'literPerHour',
      volume: 'cubicMeter',
      pressure: 'bar',
    },
  };

  private settings: KeyValueStorage;
  private numberOfDisplayedInstallations: SavedNumberOfInstallations = {
    numberOfInstallations: defaultPageSize,
  };

  setKeyValueStorage(key: string, value: KeyValueStorage): Observable<void> {
    if (!this.settings) {
      this.settings = {};
    }
    this.settings[key] = value;

    return of(null).pipe(delay(mockEndpointDelay));
  }

  getSettingsPreferences(): Observable<{
    preferences: SettingsPreferences;
  }> {
    return of(this.settingsPreferences as any);
  }

  setSettingsPreferences(preferences: SettingsPreferences): Observable<void> {
    this.settingsPreferences.preferences = preferences;

    return of(void 0);
  }

  getKeyValueStorage(key: string): Observable<KeyValueStorage> {
    if (key === 'dashboardTilesOrder') {
      return of({ data: defaultDashboardTilesOrder }).pipe(delay(mockEndpointDelay));
    }

    // VIG-15614 TODO REMOVE after implementing Learning center
    if (key === 'tutorials') {
      const mockedTutorials: TutorialsData[] = [
        {
          tutorialType: TutorialType.LandingPage,
          presented: Math.random() < 0.9,
        },
        {
          tutorialType: TutorialType.KanbanBoard,
          presented: true,
        },
        {
          tutorialType: TutorialType.KanbanInstallationList,
          presented: true,
        },
      ];

      return of({ data: mockedTutorials }).pipe(delay(mockEndpointDelay));
    }

    return of(this.settings?.[key]).pipe(delay(mockEndpointDelay));
  }

  getNumberOfDisplayedInstallations(): Observable<SavedNumberOfInstallations> {
    return of(this.numberOfDisplayedInstallations);
  }

  setNumberOfDisplayedInstallations(numberOfInstallations: number): Observable<void> {
    this.numberOfDisplayedInstallations = { numberOfInstallations };

    return of(void 0);
  }

  getWhatsAppBannerStatus(): Observable<DataBooleanStatus> {
    return of(void 0);
  }

  setWhatsAppBannerStatus(_data: boolean): Observable<DataBooleanStatus> {
    return of(void 0);
  }
}
